export const userMembersTranslation = {

  // title
  user_members_title: 9564,

  // list
  loading: 9588,
  search_hits: 9505,
  search_no_hits: 9595,
  no_access_to_subscriber_group: 9507,
  choose_value_message: 9592,
  choose_values_message: 9591,
  validation_error: 9585,

  // details
  search: 9506,
  manage_options: 9570,

  // header
  update_codes: 9586,
  show_inactive_user_members: 9583,
  subscriber_group_title: 9609,

  // error popup
  codes_update_failed: 9567,
  codes_update_failed_info_text: 9569,
  fix_selections: 9568,
  cancel: 9511,

  // messages
  message_updating: 9566,
  message_user_members_updated: 9584,
  message_user_member_info: 9590,
  message_toggle_off_info: 9587,
  message_limit_visibility: 9672,

  // items
  disabled: 9589,

  // confirmation prompt
  cancel_changes: 9512,
  are_you_sure: 9513,
  undo_all: 9514,
  go_back: 9515,

  // mark row
  mark_rows: 9571,
  mark_all_selected: 9572,
  mark_all_unselected: 9573,
  mark_all_info: 9665,
  mark_highlighted_selected: 9574,
  mark_highlighted_children_selected: 9575,
  mark_highlighted_unselected: 9576,
  visible_all: 9577,
  visible_selected: 9578,
  visible_unselected: 9579,
  visible_show_all: 9580,
  visible_show_selected: 9581,
  visible_show_unselected: 9582,
  hide_inactive_users: 9661,
  info_text: 9674,
  info_text_link: 9675,

  // filters
  filter_name: 9662,
  filter_email: 9663
};

export type UserMembersTranslation = {
  readonly [T in keyof typeof userMembersTranslation]: string
};

export const userMembersAction = {
  select: 'select',
  deselect: 'deselect',
  selectAll: 'select_all',
  deselectAll: 'deselect_all'
} as const;

export type UserMembersActionType = typeof userMembersAction[keyof typeof userMembersAction];

export const defaultMaxResults = 50;

export enum queryFilters {
  text = 'search_in_text',
  originalText = 'search_in_original_text'
}

export enum filterId {
  name = 'name',
  email = 'email'
}
